// extracted by mini-css-extract-plugin
export default {"socials":"SocialAuth_socials__VXHoA","socialsButton":"SocialAuth_socialsButton__F9Cwm"};